import { Match } from '../../types';

/**
 * Sin override en memoria — los equipos se corrigen en Firestore (manual).
 */
export function hydrateMundialKnockoutTeams(matches: Match[]): Match[] {
  return matches;
}

export async function hydrateMundialMatchesAsync(matches: Match[]): Promise<Match[]> {
  return matches;
}
